<template>
    <div class='content'>
        <h1 class='title'>{{ text }}</h1>
    </div>
</template>

<script>
export default {
    name: 'RegisterPage',
    components: {},
    data () {
        return {
            text: '認証中'
        }
    },
    methods: {
    },
    created () {
        const self = this
        const token = location.hash.split('token=')[1]

        self.axios.post(`${process.env.API_URL}/auth`, {
            token: token
        }).then((res) => {
            if (res.data.message === 'OK') {
                self.text = '認証が完了しました。5秒後にマイページへ移動します。'
                setTimeout(() => {
                    location.href = '#/photobuy/mypage'
                }, 5000)
            } else if (res.data.message === 'authenticated') {
                self.text = '既に認証を完了しています。。'
            } else if (res.data.message === 'not found') {
                self.text = '期限が切れているか無効なURLです。'
            }
        }).catch(e => {
            self.text = '予期せぬエラーが発生しました'
        })
    }
}
</script>

<style scoped>
.login {
  margin-top: 30px;
  width: 100%;
}

.content {
    max-width: 640px;
    padding: 20px;
    margin: auto;
    margin-top: 50px;
}

.register {
    width: 100%;
    margin-top: 30px;
}

.title {
    text-align: center;
    margin-bottom: 50px;
}

.sub-title {
    text-align: center;
    font-size: 1.5em;
}

.success {
    margin-top: 120px;
}
</style>



// WEBPACK FOOTER //
// src/routes/AuthPage.vue